const Footer = () => {
  return (
    <footer>
      <p>
        Réalisé par{" "}
        <a href="https://valentingbr.fr" target="blank" rel="noreferrer">
          Valentin Gaborieau
        </a>{" "}
        - API Football-Data.org
      </p>
    </footer>
  );
};

export default Footer;
